export default __webpack_public_path__ + "static/media/Alpha-FX-White.d1b3f29d.png";